import GeneralFilter from '../../../../Model/GeneralFilter'

export default class TutorialHelpFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
